<template>
  <b-row align-h="center" align-v="center" class="text-center height-all">
    <b-col md="8">
      <pulse-loader :color="color" :size="size"></pulse-loader>
    </b-col>
  </b-row>
</template>

<script>

import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

export default {
  name: 'Home',
  data () {
    return {
      color: '#444d56',
      size: '20px'
    }
  },
  components: {
    PulseLoader
  }
}
</script>

<style lang="scss" scoped>
.height-all {
  height: 90vh;
}
</style>
